import ReceiveLandingMain from "@/components/dashboard/receive/ReceiveLandingMain";

export default function ReceiveLanding() {
  return <ReceiveLandingMain />;
}
